// extracted by mini-css-extract-plugin
export default {"inStockIndicator":"StockStatus_inStockIndicator__DBpxG","outOfStockIndicator":"StockStatus_outOfStockIndicator__GTzf8","unavailable":"StockStatus_unavailable__SFsui"};